<template>
    <div class="el-float" @click="$emit('click', $event)">
        <v-tooltip bottom open-delay="250">
            <template v-slot:activator="{ on: show }">
                <v-avatar size="40" color="n1 add-user actual-add-user" class="mt-1" v-on="show">
                    <icon size="22" icon="UserPlus" />
                </v-avatar>
            </template>
            <span>{{ $t("Add member") }}</span>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    name: "AddUserButton",
    setup() {
        return {};
    }
}
</script>
